import React from 'react';
import { PaymentMethod, methodStyles } from '../paymentsTypes';
import styles from './PaymentMethodBadge.module.css';

interface PaymentMethodBadgeProps {
  method: PaymentMethod;
}

export const PaymentMethodBadge: React.FC<PaymentMethodBadgeProps> = ({ method }) => {
  const s = methodStyles[method];
  return (
    <span
      className={styles.badge}
      style={{ background: s.bg, color: s.color, borderColor: s.border }}
    >
      {method}
    </span>
  );
};
